import { useClient } from "@splitsoftware/splitio-react";
import logger from "logging/logger";
import { useEffect, useState } from "react";

export enum ClientStatus {
  PENDING = "pending",
  READY = "ready",
  TIMEOUT = "timeout",
}

type SplitClientResult =
  | {
      status: ClientStatus.READY;
      client: SplitIO.IClient;
    }
  | { status: ClientStatus.TIMEOUT; client: null }
  | { status: ClientStatus.PENDING; client: null };

export const useSplitClient = (
  ...args: Parameters<typeof useClient>
): SplitClientResult => {
  const client = useClient(...args);
  const [clientResult, setClientResult] = useState<SplitClientResult>({
    status: ClientStatus.PENDING,
    client: null,
  });

  useEffect(() => {
    // according to their docs, this is only ever null if a split factory instance
    // is not found.
    if (client === null) {
      throw new Error("No Split Context found.");
    }

    client
      .ready()
      .then(() => {
        logger.info("[split][splitClient] split sdk ready");
        setClientResult({ client, status: ClientStatus.READY });
        return undefined;
      })
      .catch(() => {
        logger.warn("[split][splitClient] split sdk timed out");
        setClientResult({ status: ClientStatus.TIMEOUT, client: null });
      });
  }, [client]);

  return clientResult;
};
